import { render, staticRenderFns } from "./EiLongFigureScroll.vue?vue&type=template&id=61d634ae&scoped=true&"
import script from "./EiLongFigureScroll.vue?vue&type=script&lang=js&"
export * from "./EiLongFigureScroll.vue?vue&type=script&lang=js&"
import style0 from "./EiLongFigureScroll.vue?vue&type=style&index=0&id=61d634ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d634ae",
  null
  
)

export default component.exports